<template>
  <div class="flex items-center">
    <span @click="onClickEdit">
      <VueFeather
        v-if="editable"
        type="edit"
        class="mt-3 mr-3 cursor-pointer feather-icon feather-icon"
      />
    </span>
    <span @click="onClickTrash">
      <VueFeather
        v-if="deletable"
        type="trash"
        class="mt-3 cursor-pointer feather-icon feather-icon"
      />
    </span>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DataTableCellActions',
  data () {
    return {
      editable: true,
      deletable: true,
      rowIndex: null
    }
  },
  beforeMount () {
    this.editable = this.params.editable
    this.deletable = this.params.deletable
    this.rowIndex = this.params.rowIndex
  },
  methods: {
    onClickEdit () {
      this.params.onClickEdit({
        index: this.rowIndex
      })
    },
    onClickTrash () {
      this.params.onClickTrash({
        index: this.rowIndex
      })
    }
  }
})
</script>

<style scoped>

</style>
